module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C154"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/06_Contents#id_1003",
      "id": "page_xiii"
    }
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', [_c('tbody', [_c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("AD")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("African Descent")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("AMA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("American Missionary Association")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("Co.")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Company")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("Col.")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Colonel")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("CRA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Contraband Relief Association")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("LSASTC")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Ladies’ Sanitary Association of St. Thomas’s African Episcopal Church")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("LUA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Ladies’ Union Association")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("PAS")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Pennsylvania Abolition Society")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("POW")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Prisoner of War")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("Regt.")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Regiment")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Record Group")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("Sgt.")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Sergeant")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("USCC")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United States Christian Commission")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("USCHA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United States Colored Heavy Artillery")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("USCI")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United States Colored Infantry")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("USCLA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United States Colored Light Artillery")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("USCT")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United States Colored Troops")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("USSC")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United States Sanitary Commission")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("WAA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("Weekly Anglo-African")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style1"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("WCRA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Women’s Central Relief Association")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c32fe4ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/08_List_of_Abbreviations.vue
// module id = 81
// module chunks = 0